const NewRelicModuleDetail = {
    title: 'Event Logs',
    nav: [
        {
            name: 'Logs',
            groupsAllowed: [],
            icon: 'cil-description',
            url: '',
        },
    ],
    loadModule: () => import('./bigfishgames-nr-event-log-viewer-new-relic.module-7c4919ce.mjs').then((m) => m.NewRelicModule),
};

/*
 * Public API Surface of new-relic
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NewRelicModuleDetail };
